<template>
  <div>
    <v-card>
      <v-expansion-panels>
    <v-expansion-panel
      v-for="(item,i) in 1"

      :key="i"
    >
      <v-expansion-panel-header>
      <v-card-title class="text-h8 info darken-1 lighten-1 py-1">
        <v-row no-gutters>
          <v-col cols="10">
            <div class="h8" style="color:white!important;">
              <v-icon color="white">mdi-information-outline</v-icon>
              Información de Encuesta
            </div>
          </v-col>
        </v-row>
      </v-card-title>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
      <v-card-text>
        <v-row class="mx-2 mt-2">
<v-col cols="3">
              <v-card    
                  class="mx-auto card-ug"
                         
                >
                  <v-card-title>
                    <v-icon 
                      class="azul-ug" 
                      large 
                      center>
                     article
                    </v-icon>
                    <span class="subtitle-1 font-weight-light azul-ug" center>
                      Ámbito y servicio
                    </span>
                  </v-card-title>
                  <v-card-text>
                    <v-row>   
                      <v-col 
                        class="py-1" 
                        cols="12"
                      >
                      <div class="subtitle-3"><b>Macroproceso</b><br>{{objFichaEncuesta.servicioProcesoClasificacion}}</div>
             <div class="subtitle-3"><b>Ámbito</b><br> {{objFichaEncuesta.encuestaAmbito}}</div>
             <div class="subtitle-3"><b>Tipo de ámbito</b><br>{{objFichaEncuesta.encuestaNombreAmbito}}</div>
             <div class="subtitle-3"><b>Servicio</b><br>{{objFichaEncuesta.nombreServicio}}</div>
            <div class="subtitle-3"><b>Campus</b><br>{{objFichaEncuesta.campus }}</div>
            <div class="subtitle-3"><b>División</b><br>{{objFichaEncuesta.division }}</div> 
            <div class="subtitle-3"><b>Departamento</b><br>{{objFichaEncuesta.departamento }}</div>
            
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
</v-col>
<v-col cols="6">
              <v-card    
                  class="mx-auto card-ug"      
                >
                  <v-card-title>
                    <v-icon 
                      class="azul-ug" 
                      large 
                      center>
                     article
                    </v-icon>
                    <span class="subtitle-1  font-weight-light azul-ug" center>
                      Generales
                    </span>
                  </v-card-title>
                  <v-card-text>
                    <v-row>   
                      <v-col 
                        class="py-1" 
                        cols="12"
                      >
            <div class="subtitle-3"><b>Nombre de la encuesta</b><br>{{objFichaEncuesta.nombreEncuesta}}</div>
             <div class="subtitle-3"><b>Objetivo</b><br>{{objFichaEncuesta.objetivoEncuesta}}</div>    
             <div class="subtitle-3"><b>Alcance</b><br>{{objFichaEncuesta.alcanceEncuesta}}</div>    
           <div class="subtitle-3"><b>Fecha de inicio</b><br>{{ getDateFormated(objFichaEncuesta.encuestaFechaInicio) }}</div>          
           <div class="subtitle-3"><b>Fecha de fin</b><br>{{ getDateFormated(objFichaEncuesta.encuestaFechaFin) }}</div>          
          <div class="subtitle-3"><b>Habilitada</b><br>{{objFichaEncuesta.encuestaHabilitada}}</div>
          <div class="subtitle-3"><b>¿Está vinculada con algún sistema?</b><br>{{objFichaEncuesta.encuestaVinculadaSistema}}</div>
          <div class="subtitle-3"><b>Sistema vinculado</b><br>{{objFichaEncuesta.SistemaModulo}}</div>           
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card></v-col>

                <v-col cols="3">
              <v-card    
                  class="mx-auto card-ug"
                         
                >
                  <v-card-title>
                    <v-icon 
                      class="azul-ug" 
                      large 
                      center>
                    face
                    </v-icon>
                    <span class="subtitle-1 font-weight-light azul-ug" center>
                      Enlace
                    </span>
                  </v-card-title>
                  <v-card-text>
                    <v-row>   
                      <v-col 
                        class="py-1" 
                        cols="12"
                      >
             <div class="subtitle-3"><b>Enlace</b><br>{{objFichaEncuesta.enlaceNombre}}</div> 
              <div class="subtitle-3"><b>Correo del enlace</b><br>{{objFichaEncuesta.enlaceCorreo}}</div>          
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
                              <v-card    
                  class="mx-auto card-ug"
                >
                  <v-card-title>
                    <v-icon 
                      class="azul-ug" 
                      large 
                      center>
                     fact_check
                    </v-icon>
                    <span class="subtitle-1 font-weight-light azul-ug" center>
                      Respuestas
                    </span>
                  </v-card-title>
                  <v-card-text>
                    <v-row>   
                      <v-col 
                        class="py-1" 
                        cols="12"
                      >
             <div class="subtitle-3"><b>Total enviadas</b><br>{{objFichaEncuesta.total }}</div>
            <div class="subtitle-3"><b>Total contestadas</b><br>{{objFichaEncuesta.contestadas}}</div>   
            <div class="subtitle-3"><b>Promedio encuesta</b><br>{{objPromedioEncuesta}}</div>   
             
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
                </v-col>
        </v-row>
      </v-card-text>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
    </v-card>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  name: "InfoEncuesta",
  components: {
  },
  props: {
    objEncuesta: {
      type: Object,
      default: function () {
        return {
          idEncuesta: 0,
        }
      }
    },
    objFichaEncuesta: {
      type: Object,
      require:true
    },
    objPromedioEncuesta: {
      type: Number,
      required: true,
    },
     
  },
  data () {
    return {
    };
  },
  computed: {
  },
  beforeMount () {},
  async mounted () {
  },
  methods: {
    getDateFormated(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY hh:mm a');
      }
      else{
        return 'N/D';
      }
    },
  }
};
</script>